export class User {
  /** Email */
  public email: string

  /** Creation date ISO */
  // eslint-disable-next-line camelcase
  public created_on: string

  /** Role (user or admin) */
  public role: 'USER' | 'ADMIN'

  constructor(user: User) {
    this.email = user.email || ''
    this.created_on = user.created_on || ''
    this.role = user.role || 'USER'
  }
}
